export default class Profissional {
    private _id = Number();
    private _ativo = Boolean();
    private _dtInclusao = new Date();
    private _dtAlteracao = new Date();
    private _usuario = String();
    private _usuarioUpdate = String();
    private _nome = String();
    private _sigla = String();
    private _numero = String();
    private _uf = String();
    private _cbos = String();

    public get id() {
        return this._id;
    }
    public set id(value) {
        this._id = value;
    }
    public get ativo() {
        return this._ativo;
    }
    public set ativo(value) {
        this._ativo = value;
    }
    public get dtInclusao() {
        return this._dtInclusao;
    }
    public set dtInclusao(value) {
        this._dtInclusao = value;
    }
    public get dtAlteracao() {
        return this._dtAlteracao;
    }
    public set dtAlteracao(value) {
        this._dtAlteracao = value;
    }
    public get usuario() {
        return this._usuario;
    }
    public set usuario(value) {
        this._usuario = value;
    }
    public get usuarioUpdate() {
        return this._usuarioUpdate;
    }
    public set usuarioUpdate(value) {
        this._usuarioUpdate = value;
    }
    public get nome() {
        return this._nome;
    }
    public set nome(value) {
        this._nome = value;
    }
    public get sigla() {
        return this._sigla;
    }
    public set sigla(value) {
        this._sigla = value;
    }
    public get numero() {
        return this._numero;
    }
    public set numero(value) {
        this._numero = value;
    }
    public get uf() {
        return this._uf;
    }
    public set uf(value) {
        this._uf = value;
    }
    public get cbos() {
        return this._cbos;
    }
    public set cbos(value) {
        this._cbos = value;
    }

    constructor(pId: number, pAtivo: boolean, pDtInclusao: Date, pDtAlteracao: Date, pUsuario: string, pUsuarioUpdate: string, pNome: string, pSigla: string, pNumero: string, pUf: string, pCbos: string,) {
        this.id = pId;
        this.ativo = pAtivo;
        this.dtInclusao = pDtInclusao;
        this.dtAlteracao = pDtAlteracao;
        this.usuario = pUsuario;
        this.usuarioUpdate = pUsuarioUpdate;
        this.nome = pNome;
        this.sigla = pSigla;
        this.numero = pNumero;
        this.uf = pUf;
        this.cbos = pCbos;
    }
}